import axios from "axios";
import Vue from "vue";

/**
 * @category Headers ::
 * ::::::::::::::::::::::::::::::::::::::::::::::::::::
 */
var config = {
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
};

Vue.prototype.$http = axios;

/**
 * @category Route ::
 * ::::::::::::::::::::::::::::::::::::::::::::::::::::
 */
const baseUri = 'https://api.recc.com.mx/api/';
// const baseUri = 'https://apirecc.gponestore.com.mx/api/';
// const baseUri = 'https://apirecc.partnersbusinesses.com/api/';
// const baseUri = "http://apirecc.test/api/";

var api = {
  baseUri: baseUri,

  baseUriFiles: "https://api.recc.com.mx/storage/",
  // baseUriFiles: "https://apirecc.gponestore.com.mx/storage/",
  // baseUriFiles: "https://apirecc.partnersbusinesses.com/storage/",
  // baseUriFiles: "http://apirecc.test/storage/",

  get: function(endpoint, params = null, show_lodader = false) {
    var url = new URL(baseUri + endpoint);

    if (params) {
      Object.keys(params).forEach(function(key) {
        url.searchParams.append(key, params[key]);
      });
    }

    show_lodader ? api.loader(true) : null;

    return new Promise((resolve) => {
      axios.get(url.href, config).then((response) => {
        show_lodader ? api.loader(false) : null;
        resolve(response);
      });
    });
  },
  post: function(endpoint, data, show_lodader = false) {
    show_lodader ? api.loader(true) : null;

    var postConfig = config;
    if (data instanceof FormData) {
      postConfig = { headers: { ...config.headers } };
      delete postConfig.headers["Content-Type"];
    }

    return new Promise((resolve, reject) => {
      axios.post(baseUri + endpoint, data, postConfig).then(
        (response) => {
          show_lodader ? api.loader(false) : null;
          resolve(response);
        },
        (error) => {
          show_lodader ? api.loader(false) : null;
          reject(error);
        }
      );
    });
  },
  authorization: function(status, token) {
    if (status) {
      return (axios.defaults.headers.common["Authorization"] =
        "Bearer " + token);
    } else {
      return delete axios.defaults.headers.common["Authorization"];
    }
  },
};

export default api;
